var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCoupon(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16.25 2.91797L15 1.66797L13.75 2.91797L12.5 1.66797L11.25 2.91797L10 1.66797L8.75 2.91797L7.5 1.66797L6.25 2.91797L5 1.66797L3.75 2.91797L2.5 1.66797V18.3346L3.75 17.0846L5 18.3346L6.25 17.0846L7.5 18.3346L8.75 17.0846L10 18.3346L11.25 17.0846L12.5 18.3346L13.75 17.0846L15 18.3346L16.25 17.0846L17.5 18.3346V1.66797L16.25 2.91797ZM15.8333 15.9096H4.16667V4.09297H15.8333V15.9096ZM5 12.5013H15V14.168H5V12.5013ZM5 9.16797H15V10.8346H5V9.16797ZM5 5.83464H15V7.5013H5V5.83464Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCoupon);
export default __webpack_public_path__ + "static/media/coupon.0cc5a2a0371302d09674d85c3e98dd47.svg";
export { ForwardRef as ReactComponent };